import React , {useState} from "react";
import { useSelector  } from "react-redux";


import { useCommerciaux } from "../../state/reactquery";

import { queryClient } from '../../state/queryClient';


import { modifyoneleadfrontback } from "../../utils/actions_lead";
import { axios_clients_commercialchange , axios_clients_searchclientbyid } from "../../axios/axios_clients";


import Boulettes from "../../Components/ContratWin/Boulettes";
import ButtonSimple from "../../Components/Buttons/ButtonSimple";

import croixclose from '../../images/croixclose.svg';

import './PopupReassigner.scss' ;

function PopupReassigner({setShowpopupreassigner,listidchangecom,setListidchange}){


    const {data:commerciaux} = useCommerciaux() ;
    const lead =  useSelector(state=>state.lead.leadactu);
    const {date1,date2,typetablo}=  useSelector(state=>state.gestion);
    


    const typedate = typetablo==='gestion'?'date_origine' : 'date_lastmodif' ; 

    const [etape, setEtape] = useState(1) ;
    const [newcommercial, setNewcommercial] = useState(null) ;

    async  function  changeoneleadcommercial(idlead){
        const reqlead =await axios_clients_searchclientbyid(idlead) ;
        modifyoneleadfrontback({...reqlead?.data, commercial:newcommercial})
        await axios_clients_commercialchange({idlead,commercial_new:newcommercial});
    }

    const reattribution= async() =>{
        await Promise.all(listidchangecom.map((id) => changeoneleadcommercial(id)));
        queryClient.invalidateQueries({ queryKey: ['leadsandfauxnumeros',date1,date2,typedate]}) ;
        setListidchange([]) ;
        setShowpopupreassigner(null) ;  
    }
    
    const avance = ()=>{ etape===1? setEtape(2) : reattribution() ;
}

    const defineewcommercial = (e)=>{e.target.value !=='Commercial' &&  setNewcommercial(e.target.value) ;}

    return(<div  className="containergray">
               <div className="ecrangestionreassigner">
               <div className="cardresilitationclose" ><img src={croixclose}  alt="imgclose" onClick={()=> setShowpopupreassigner(null) }  /></div>

                <div className="ecrangestionreassigner_titre center" >Réaffectation</div>
                <Boulettes total={3} etape={etape} />
             { etape===1 ? <> 
                <div className="ecrangestionreassigner_titre left" >A qui souhaitez-vous réaffecter ces {listidchangecom?.length||0} leads ?</div>  

             <div className="ecrangestionreassigner_texte">Nom de l’utilisateur</div>
                <select     className='selectcom' onChange={defineewcommercial} >
                                        <option className='selectcom_option' value={undefined} >Commercial</option>
                                        {commerciaux?.map((x,i)=><option key={i}  value={x} >{x?.toUpperCase()}</option>)}
                 </select><br/><br/>
                <div className="ecrangestionreassigner_btns" >
                    <ButtonSimple  texte="Continuer" containerbouton='fullbutonX'  color='bouton_color_orange' size='bouton_size_normal' disable={newcommercial===null} onclick={avance}  />
                </div></>:<>
                <div className="ecrangestionreassigner_titre center"  >Souhaitez-vous réellement réaffecter ces {listidchangecom?.length||0} leads à {newcommercial?.toUpperCase()} ?</div>
                <div  className="ecrangestionreassigner_texte center" >Cette opération est irréversible</div><br/><br/>
                <div className="ecrangestionreassigner_btns" >
                    <ButtonSimple  texte="Retour"  color='bouton_color_blancgris' size='bouton_size_normal' disable={newcommercial===null} onclick={()=>setEtape(1)}  />
                    <ButtonSimple  texte="Confirmer"  color='bouton_color_orange' size='bouton_size_normal' disable={newcommercial===null} onclick={avance}  />
                </div></>}
               </div>
           </div>)
}


export default PopupReassigner